import React from 'react'
import PropTypes from 'prop-types'
import { PromotionItems, PromotionItemsCarousel } from './PromotionItems'
import CallToActionContainer from 'LiveBoard/containers/CallToActionContainer'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'
import { Button, BUTTON_SIZES, BUTTON_TYPES } from 'shared/UI/Button'
import {
  LIVE_BOARD_CLASSNAMES,
  PROMO_AREA_COLUMNS_ALIGNMENT_CLASSES,
  PROMO_AREA_COLUMNS_SIZE_CLASSES,
  PROMO_AREA_COLUMNS_IN_ROW_CLASSES
} from 'shared/constants'
import CAMPAIGN_CONFIG from 'common/constants/CampaignEditorConfig'
import { SMALL_COLUMNS_IN_ROW } from 'common/constants/CampaignPromotionConfig'
const get = require('lodash/get')
import { TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const LARGE_ICON_CONFIG = 1

const Promotion = ({ config, themeColorHex, index, numberOfItemsPerSlide }) => {
  const promotionTitle = get(config, "title.title", config.title.main)
  const promotionSubTitle = get(config, "title.subtitle", config.title.sub)

  const getItemInRowClass = () => {
    // this function takes care of promo area items in row configuration
    // especially when no such configuration is selected
    let columnsInRowConfig
    if (config.columns.columns_in_row) {
      columnsInRowConfig = config.columns.columns_in_row
    }
    else if (config.columns.size == CAMPAIGN_CONFIG.columns_sizes.large.value) {
      columnsInRowConfig = SMALL_COLUMNS_IN_ROW.three.value
    }
    else {
      columnsInRowConfig = SMALL_COLUMNS_IN_ROW.four.value
    }
    return PROMO_AREA_COLUMNS_IN_ROW_CLASSES[columnsInRowConfig]
  }

  return config.show && (
    <section className={LIVE_BOARD_CLASSNAMES['promotion' + index]}>
      { (promotionTitle || promotionSubTitle) && (
          <div className='promotion-area-text'>
            <h1>{promotionTitle}</h1>
            <p>{promotionSubTitle}</p>
          </div>
        )
      }
      { (config.columns && config.columns.show && config.columns.show_carousel) && (
        <PromotionItemsCarousel
          items={config.columns.items}
          numberOfItemsPerSlide={numberOfItemsPerSlide}
          showIcons={config.columns.show_icons}
          textAlignmentClass={PROMO_AREA_COLUMNS_ALIGNMENT_CLASSES[config.columns.alignment]}
          iconSizeClass={PROMO_AREA_COLUMNS_SIZE_CLASSES[config.columns.size]}
          themeColorHex={themeColorHex} />
      )}

       { (config.columns && config.columns.show && !config.columns.show_carousel) && (
        <PromotionItems
          items={config.columns.items}
          itemInRowClass={getItemInRowClass()}
          showIcons={config.columns.show_icons}
          textAlignmentClass={PROMO_AREA_COLUMNS_ALIGNMENT_CLASSES[config.columns.alignment]}
          iconSizeClass={PROMO_AREA_COLUMNS_SIZE_CLASSES[config.columns.size]}
          themeColorHex={themeColorHex} />
      )}

      { config.cta.show && (
        <CallToActionContainer
          config={{...config.cta}}
          area={CTA_AREAS.promotion}
          themeColorHex={themeColorHex}
          tabIndex={TAB_INDEXES.PromotionCallToActionContainer}
          renderCustomButton={(onClick) => (
            <Button
              className="promotion-cta-button"
              type={BUTTON_TYPES.secondary}
              size={BUTTON_SIZES.medium}
              customStyle={{
                color: themeColorHex,
                border: `2px solid ${themeColorHex}`,
                backgroundColor: 'transparent'
              }}
              onClick={onClick}
            >
              <label>{config.cta.text}</label>
            </Button>
          )} />
      )}
    </section>
  )
}

Promotion.propTypes = {
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default Promotion
